
    import {toRefs, reactive, watch} from 'vue'
    import {Popover} from 'scvant';
    interface State {
        dataList: object[];
        moreStatus: boolean;
        showOrHide: number;
    }
    export default {
        name: "infoList",
        props: {
            dataList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            labelWidth: {
                type: String,
                default: '100%'
            },
            valueWidth: {
                type: String,
                default: '100%'
            },
            direction: {
                type: Boolean,
                default: false
            },
            isShowMore: {
                type: Boolean,
                default: false
            },
            dataType: {
                type: String,
                default: ''
            },
            defaultLength: {
                type: Number,
                default: 8
            }
        },
        setup(props: any) {
            let state: State = reactive({
                dataList: [],
                moreStatus: false,
                showOrHide: 1, // 0 展开状态， 1 收起状态，
                showTip: false
            })
            const {dataList, defaultLength} = toRefs(props)
            watch(props, () => {
                if (props.isShowMore && dataList.value.length > defaultLength.value) {
                    state.moreStatus = true;
                    state.dataList = dataList.value.slice(0, defaultLength.value);
                } else {
                    state.dataList = dataList.value;
                }
            })
            const onSelect = (action: { text: string }) => console.log(action.text);
            function changeListStatus() {
                if (state.showOrHide) {
                    state.showOrHide = 0;
                    state.dataList = dataList.value;
                } else {
                    state.showOrHide = 1;
                    state.dataList = dataList.value.slice(0, defaultLength.value);
                }
            }
            return {
                state,
                onSelect,
                changeListStatus
            }
        },
        methods: {
            
        },
        components: {
            [Popover.name]: Popover,
        }
    }
